module.exports = __webpack_public_path__ + "img/Capture-893.105b3c41.jpg";